import { numberToPrettyString } from '@cian/utils';

import { isCommercialLand } from './isCommercialLand';
import { IOffer } from '../../../types/offer';

export function getCommercialPerMeterByYear(offer: IOffer): string | undefined {
  if (!offer.pricePerUnitAreaPerYearRur) {
    return undefined;
  }

  let unit = 'м²';

  if (isCommercialLand(offer)) {
    unit = offer.land?.areaUnitType === 'hectare' ? 'га' : 'сот.';
  }

  return `${numberToPrettyString(offer.pricePerUnitAreaPerYearRur)} ₽/${unit} в год`;
}
